var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showForm && _vm.notes && _vm.notes.trim())?_c('p',{staticClass:"is-size-7 mb-0"},[_c('span',{staticClass:"has-white-space-pre-line"},[_vm._v(_vm._s(_vm.notes))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }